/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetProjectReleasePlansPathParams = NonNullable<operations['GetProjectReleasePlans']['parameters']['path']>;

export type GetProjectReleasePlansQueryParams = NonNullable<
  operations['GetProjectReleasePlans']['parameters']['query']
>;

export interface Input extends GetProjectReleasePlansPathParams {
  apiVersion?: string;
  query: GetProjectReleasePlansQueryParams;
  header: NonNullable<operations['GetProjectReleasePlans']['parameters']['header']>;
}

export async function GetProjectReleasePlans(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/release-plans', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
